import { render, staticRenderFns } from "./organize-design.vue?vue&type=template&id=31481f4e&scoped=true"
import script from "./organize-design.vue?vue&type=script&lang=js"
export * from "./organize-design.vue?vue&type=script&lang=js"
import style0 from "./organize-design.vue?vue&type=style&index=0&id=31481f4e&prod&lang=less&scoped=true"
import style1 from "./organize-design.vue?vue&type=style&index=1&id=31481f4e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31481f4e",
  null
  
)

export default component.exports